/* import __COLOCATED_TEMPLATE__ from './sh-invoice-transactions-list.hbs'; */
import Component from '@ember/component';

/**
 * This is the list of all of the transactions for the ShInvoice
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'div',
  classNames: ['SH-c-sh-invoice-transactions-list'],

  /**
   * Register services
   */

  /*********************************
   * REQUIRED PARAMS
   *********************************/
  /** @type {Function} */
  addTransaction: () => {},

  /** @type {Function} */
  editTransaction: (shInvoiceTransaction) => {},

  /** @type {Function} */
  deleteTransaction: (shInvoiceTransaction) => {},

  /**
   * @param {ShInvoice}
   */
  shInvoice: null,

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  /*********************************
   * PRIVATE
   **********************************/

  actions: {
    /**
     *
     */
    addTransaction: function() {
      this.get('addTransaction')();
    }
  }
});
